import { useEffect } from 'react'

let locks = 0

/**
 * Ref-counted `body.is-locked`.
 *
 * The mobile drawer and every overlay want the page frozen, and they overlap — a
 * modal opened over an open drawer, for instance. Counting means the last one out
 * unlocks, instead of whichever effect happens to clean up first.
 */
export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined

    locks += 1
    document.body.classList.add('is-locked')

    return () => {
      locks -= 1
      if (locks === 0) document.body.classList.remove('is-locked')
    }
  }, [active])
}
